export default {
  setCategory ({ commit }, params) {
    commit('setCategory', params)
  },
  setCheckout ({ commit }, params) {
    commit('setCheckout', params)
  },
  setProject ({ commit }, params) {
    commit('setProject', params)
  },
  setRelease ({ commit }, params) {
    commit('setRelease', params)
  },
  setOngoing ({ commit }, params) {
    commit('setOngoing', params)
  },
  setClosed ({ commit }, params) {
    commit('setClosed', params)
  },
  // 终端人的项目管理
  setProjectManagement ({ commit }, params) {
    commit('setProjectManagement', params)
  },
  clearSelect ({ commit }, params) {
    commit('clearSelect', params)
  }
}
